import { h, Component } from 'preact';
import ScrollArrows from 'components/shared/embedMode/scrollArrows';
import s from 'components/shared/embedMode/embedMode.sss';
import { joinClasses } from 'utils/utils';

export default class EmbedMode extends Component {
	constructor(props) {
		super(props);

		this.touchEnd = this.touchEnd.bind(this);
		this.scrollAttempt = this.scrollAttempt.bind(this);
		this.scrollAttemptFinished = this.scrollAttemptFinished.bind(this);

		this.counter = 0;
		this.state.scrolling = false;
	}

	componentWillMount() {
		// Start tracking if the user is trying to scroll
		document.addEventListener('touchmove', this.scrollAttempt);
		document.addEventListener('touchend', this.touchEnd);
	}

	componentWillUnmount() {
		document.removeEventListener('touchmove', this.scrollAttempt);
		document.removeEventListener('touchend', this.touchEnd);
	}

	touchEnd() {
		this.counter = 0;
	}

	scrollAttempt() {
		// NOTE: this should probably become an actual counter
		// as this will be inconsistent
		this.counter++;

		if (!this.state.scrolling && this.counter > 10) {
			// Added the counter so there is a bit of a buffer
			// so we are sure the user is actually scrolling
			// User has started the scroll
			this.setState({ scrolling: true });

		}

		clearInterval(this.timer);
		this.timer = setTimeout(this.scrollAttemptFinished, 500);
	}

	scrollAttemptFinished() {
		// User has finished scrolling a while ago
		this.setState({ scrolling: false });
		// Reset the counter
		this.counter = 0;
	}

	render() {
		return (
			<div>
				<div class={joinClasses({ s, noScrollContainer: true, active: this.state.scrolling })}>Use Arrows Bellow to Scroll</div>
				<ScrollArrows />
			</div>
		);
	}
}
